export default __webpack_public_path__ + "static/Крысиные бега_8-aaa782b1062c98c0f5a70c3f488aa674.jpg";